import React, { useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import Hamburger from './Hamburger';
import routes from '../../data/routes';

// Websites Navbar, displays routes defined in 'src/data/routes'
const Navigation = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.toggle('home', pathname === '/');
    return () => document.body.classList.remove('home');
  }, [pathname]);

  return (
    <header id="header">
      <h1 className="index-link">
        <Link to="/">Iris Steele</Link>
      </h1>
      <nav className="links">
        <ul>
          {routes.filter((l) => !l.index).map((l) => (
            <li key={l.label}>
              <NavLink to={l.path}>{l.label}</NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <Hamburger />
    </header>
  );
};

export default Navigation;
